import axios from 'axios'
import {identityAuth} from '../auth'

let isInterceptorConfigured = false

const getToken = () => {
  const authToken = identityAuth?.getToken?.()
  const localToken = localStorage.getItem('token')
  const token = authToken || localToken

  if (!token) {
    return null
  }

  return token.startsWith('Bearer ') ? token : `Bearer ${token}`
}

const attachAuthorizationHeader = config => {
  const token = getToken()
  const headers = config.headers || {}

  if (token) {
    headers.Authorization = token
  } else {
    delete headers.Authorization
  }

  return {
    ...config,
    headers,
  }
}

const setupAxiosAuth = () => {
  if (isInterceptorConfigured) {
    return
  }

  axios.interceptors.request.use(attachAuthorizationHeader)
  isInterceptorConfigured = true
}

export {setupAxiosAuth, attachAuthorizationHeader}
